module.exports = __webpack_public_path__ + "img/hr-tree-03-e-leaves.5af521bb.png";